import React from "react";
import { Button, Popover, SpaceBetween } from "@amzn/awsui-components-react";
import DatePicker from "@amzn/awsui-components-core/date-picker";
import FormField from "@amzn/awsui-components-core/form-field";

interface Props {
  from: string;
  to: string;
  error?: string;
  onChange: (dates: { orderDateFrom: string; orderDateTo: string }) => void;
}

export function OrderDateFilter({ from, to, error, onChange }: Props) {
  const label = from || to ? `${from || "Any"} – ${to || "Any"}` : "Order date";
  return (
    <Popover
      triggerType="custom"
      position="bottom"
      header="Original order date (UTC)"
      content={
        <SpaceBetween size="s">
          <FormField label="From (inclusive)" errorText={error}>
            <DatePicker
              value={from}
              placeholder="YYYY-MM-DD"
              format="iso"
              inputFormat="iso"
              ariaLabel="Order date from (UTC)"
              onChange={({ detail }) =>
                onChange({ orderDateFrom: detail.value, orderDateTo: to })
              }
              expandToViewport
            />
          </FormField>
          <FormField label="To (inclusive)">
            <DatePicker
              value={to}
              placeholder="YYYY-MM-DD"
              format="iso"
              inputFormat="iso"
              ariaLabel="Order date to (UTC)"
              onChange={({ detail }) =>
                onChange({ orderDateFrom: from, orderDateTo: detail.value })
              }
              expandToViewport
            />
          </FormField>
          <span>
            Filters candidates in the processing window. Orders without a known
            original date are excluded.
          </span>
          <Button
            onClick={() => onChange({ orderDateFrom: "", orderDateTo: "" })}
          >
            Clear order dates
          </Button>
        </SpaceBetween>
      }
    >
      <Button data-testid="order-date-filter" iconName="calendar">
        {label}
      </Button>
    </Popover>
  );
}
